module.exports = "<input type=\"checkbox\">\r\n"